import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class WidgetHeader extends Component
{
    static displayName = 'WidgetHeader';

    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.arrayOf(PropTypes.object)
        ]),
        headerText: PropTypes.object.isRequired,
        iconStyle: PropTypes.object,
        headerStyle: PropTypes.object
    };

    constructor(props)
    {
        super(props);
    }

    render()
    {
        return (
            <div style={{ ...styles.headerContainer, ...this.props.headerStyle }}>
                <span style={styles.widgetHeader}>
                    {this.props.headerText.widgetTitle}
                    {this.props.headerText.subWidgetTitle && <span style={styles.subWidgetTitle}>{ this.props.headerText.subWidgetTitle }</span>}
                </span>
                <span style={{ ...styles.iconContainer, ...this.props.iconStyle }}>
                    {this.props.children}
                </span>
            </div>
        );
    }
}

const styles = {
    headerContainer: {
        width: '100%',
        display: 'flex',
        padding: '5px 10px',
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #eee',
        color: '#555',
        minHeight: 26,
        verticalAlign: 'middle',
        fontSize: 16,
        fontWeight: 600,
        borderTopLeftRadius: '2px',
        borderTopRightRadius: '2px'
    },
    widgetHeader: {
        textAlign: 'left',
        minHeight: '26px',
        verticalAlign: 'middle',
        textTransform: 'uppercase',
        width: 'calc(100% - 6px)',
        paddingTop: 3,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    iconContainer: {
        position: 'relative',
        width: '6px',
        height: '26px',
        marginLeft: '8px'
    },
    subWidgetTitle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontWeight: 400,
        margin: '0px 8px',
        textTransform: 'none'
    }
};
